import { render, staticRenderFns } from "./RightshipCompanyList.vue?vue&type=template&id=24b98e96&scoped=true&"
import script from "./RightshipCompanyList.vue?vue&type=script&lang=js&"
export * from "./RightshipCompanyList.vue?vue&type=script&lang=js&"
import style0 from "./RightshipCompanyList.vue?vue&type=style&index=0&id=24b98e96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b98e96",
  null
  
)

export default component.exports